export function isImageFile(filePath: string): boolean {
  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp'];

  return imageExtensions.some((ext) => filePath.toLowerCase().endsWith(ext));
}
